function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#4038FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.413 15l-.707.707-10 10-.707.707-.707-.707-5-5-.706-.707L12 18.586l.707.707L17 23.586l9.293-9.293.707-.707L28.413 15z",
  fill: "#fff"
});

var SvgIconPlayed = function SvgIconPlayed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM0MDM4RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOC40MTI5IDE1TDI3LjcwNTggMTUuNzA3MUwxNy43MDU4IDI1LjcwNzFMMTYuOTk4NiAyNi40MTQzTDE2LjI5MTUgMjUuNzA3TDExLjI5MjkgMjAuNzA3TDEwLjU4NTkgMTkuOTk5OEwxMi4wMDA0IDE4LjU4NThMMTIuNzA3NCAxOS4yOTNMMTYuOTk4OCAyMy41ODU3TDI2LjI5MTYgMTQuMjkyOUwyNi45OTg3IDEzLjU4NThMMjguNDEyOSAxNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgIconPlayed as ReactComponent };